import api from "../../../../common/dependencies/utils/Api";
import {
  COHORT_REQUEST_MENTOR_DASHBOARD,
  DASHBOARD_MENTOR_MYREQUEST,
  DASHBOARD_MENTOR_HOME,
  MENTORSHIP_APPLICATION,
  MENTORSHIP_STARTUP_APPLICATION,
  MENTORSHIP_STARTUP_APPLICATION_STATUS,
  VIEW_COUNTER_MENTOR_OPTIONS,
  POST_SUMMARY_MENTOR_DATA,
  GET_MENTOR_FEEDBACK,
  POST_MENTOR_FEEDBACK,
  GET_MENTOR_COHORT_APPLICATIONS,
  GET_MENTOR_MODULE_COHORT_LIST,
  GET_MENTOR_MODULE_STARTUP_COHORT_LIST,
  GET_MENTOR_MODULE_COHORT_COUNTER,
  GET_MENTOR_MODULE_STARTUP_COHORT_COUNTER,
  GET_MENTOR_MODULE_COHORT_STATUS,
  GET_MENTOR_MODULE_STARTUP_COHORT_STATUS,
  MATCH_COHORT_TABLE,
  MATCH_STARTUP_LIST,
  MATCH_MENTOR_LIST,
  MATCH_CREATE_REQUEST,
  MATCH_RESULT_LIST,
  GET_CREATE_COHORT_GROUP_SESSION,
  GET_DELETE_COHORT_GROUP_SESSION,
  GET_DETAILS_COHORT_GROUP_SESSION,
  GET_LIST_COHORT_GROUP_SESSION,
  GET_LIST_SESSION_MEMBERS,
  UPDATE_SESSION_STATUS,
  GET_LIST_COHORT_GROUP_SESSION_COUNTERS,
  GET_LIST_COHORT_INVITATION,
  COHORT_SESSION_GIVE_FEEDBACK,
  COHORT_SESSION_VIEW_FEEDBACK,
  COHORT_SESSION_NOTES_GIVE_FEEDBACK,
  COHORT_SESSION_NOTES_VIEW_FEEDBACK,
  COHORT_GROUP_SESSION_HOURS,
  COHORT_GROUP_SESSION_HOURS_FILTER,
  POST_SUMMARY_STARTUP_DATA,
  COHORT_PROGRAM_SPOTLIGHT_POST,
  COHORT_COMMON_LIST_POST,
  COHORTS_DISCUSSION_POST_API,
  COHORTS_DISCUSSION_LIST_API,
  COHORTS_DISCUSSION_COMMENT_LIST_API,
  COHORTS_DISCUSSION_POST_COMMENT_API,
  COHORTS_LIKE_POST_COMMENT_API,
  COHORTS_LIKE_POST_THREAD_API,
  COHORTS_UNLIKE_POST_COMMENT_API,
  COHORTS_UNLIKE_POST_THREAD_API,
  COHORTS_THREAD_POST_REMOVE_API,
  COHORTS_POST_COMMENT_REMOVE_API,
  COHORTS_POST_COMMENT_REPLY_API,
  COHORTS_POST_COMMENT_REPLY_LIST_API,
  COHORTS_DASHBOARD_ACTIVITY_API,
  COHORTS_DASHBOARD_MENTOR_API,
  COHORTS_DASHBOARD_STARTUP_API,
} from "../../../../common/constants/ApplicationUrl";
import swal from "sweetalert";

export const MentorServices = {
  getCohortRequest(params) {
    return api
      .POST(`${COHORT_REQUEST_MENTOR_DASHBOARD}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  dashboardMentorMyrequest() {
    return api
      .GET(`${DASHBOARD_MENTOR_MYREQUEST}`)
      .then((response) => {
        const { data: { responseCode, data } = {} } = response;
        if (responseCode === 200) {
          return data;
        } else {
          return Promise.reject(response.data);
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  dashboardMentorHome(params) {
    return api
      .POST(`${DASHBOARD_MENTOR_HOME}`,params)
      .then((response) => {
        
        
        const { data, status } = response || {};
        if (status === 200) {
          //
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getMentorApplicationStatus(params) {
    return api
      .POST(`${MENTORSHIP_APPLICATION}`,params)
      .then((response) => {
        
        
        const { data, status } = response || {};
        if (status === 200) {
          //
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getStartUpAppListMentorDash(params) {
    return api
    .POST(`${MENTORSHIP_STARTUP_APPLICATION}`,params)
    .then((response) => {
      
      
      const { data, status } = response || {};
      if (status === 200) {
        //
        return response.data;
      } else {
        return { status: false };
      }
    })
    .catch((e) => {
      return Promise.reject(e);
    });
  },
  setStartUpAppStatus(params) {
    return api
    .POST(`${MENTORSHIP_STARTUP_APPLICATION_STATUS}`,params)
    .then((response) => {
      
      
      const { data, status } = response || {};
      
      if (response === undefined){
         swal({
          title: "WARNING",
          text: `Failed to  `+params.status+` Request `,
          icon: "info",
          // timer: 4500,
          // buttons: false,
        });
        return false;
      }
      if (status === 200) {
        
        swal({
          title: "Success",
          text: `Request `+ params.status+` Successfully `,
          icon: "success",
          // timer: 2500,
          // buttons: false,
        });
        return response.data;       
        
      } else {
        return { status: false };
      }
    })
    .catch((e) => {
      return Promise.reject(e);
    });
  },
  getCountersMentorList(params) {
    return api
      .POST(`${VIEW_COUNTER_MENTOR_OPTIONS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postMentorFeedback(params) {
    return api
      .POST(`${POST_MENTOR_FEEDBACK}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getMentorFeedback(params) {
    return api
      .POST(`${GET_MENTOR_FEEDBACK}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postMentorSessionData(params) {
    return api
      .POST(`${POST_SUMMARY_MENTOR_DATA}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getMentorCohortApplicationList(params) {
    return api
      .POST(`${GET_MENTOR_COHORT_APPLICATIONS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getMentorModuleCohortList(params) {
    return api
      .POST(`${GET_MENTOR_MODULE_COHORT_LIST}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postSummaryData(params){
    return api
    .POST(`${POST_SUMMARY_STARTUP_DATA}`, params)
    .then((response) => {
      const { data, status } = response || {};
      if (status === 200) {
        return response.data;
      } else {
        return { status: false };
      }
    })
    .catch((e) => {
      return Promise.reject(e);
    });
  },
  getMentorModuleStartupCohortList(params) {
    return api
      .POST(`${GET_MENTOR_MODULE_STARTUP_COHORT_LIST}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
      
         
          // return { status: false };
        }
      })
      .catch((e) => {
      

       
        return Promise.reject(e);
      });
  },
  setMentorModuleStartupCohortStatus(params) {
    return api
      .POST(`${GET_MENTOR_MODULE_STARTUP_COHORT_STATUS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          swal({
            title: "Thank You ",
            text: `Mentor Request `+params?.equestStatus+` Successfully!! `,
            icon: "info",
          });
          return response.data;
          
        } else {
          swal({
            title: "WARNING",
            text: `Failed to Update Request `,
            icon: "info",
          });
          return { status: false };
        }
      })
      .catch((e) => {  
         swal({
        title: "WARNING",
        text: `Failed to Update Request `,
        icon: "info",
      });
        return Promise.reject(e);
      });
  },
  setMentorModuleMentorCohortStatus(params) {
    return api
      .POST(`${GET_MENTOR_MODULE_COHORT_STATUS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          swal({
            title: "Thank You ",
            text: `Mentor Request `+params?.equestStatus+` Successfully!! `,
            icon: "info",
          });
          return response.data;
        } else {
          swal({
            title: "WARNING",
            text: `Failed to Update Request `,
            icon: "info",
          });
          return response.data;
        }
      })
      .catch((e) => {
        swal({
          title: "WARNING",
          text: `Failed to Update Request `,
          icon: "info",
        });
        return Promise.reject(e);
      });
  },
  getMentorModuleStartupCohortCounter(params) {
    return api
      .POST(`${GET_MENTOR_MODULE_STARTUP_COHORT_COUNTER}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getMentorModuleMentorCohortCounter(params) {
    return api
      .POST(`${GET_MENTOR_MODULE_COHORT_COUNTER}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getMatchCohortList(params) {
    return api
      .POST(`${MATCH_COHORT_TABLE}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getMatchStartupList(params) {
    return api
      .POST(`${MATCH_STARTUP_LIST}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getMatchMentorList(params) {
    return api
      .POST(`${MATCH_MENTOR_LIST}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getMatchCreateRequest(params) {
    return api
      .POST(`${MATCH_CREATE_REQUEST}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getMatchResultList(params) {
    return api
      .POST(`${MATCH_RESULT_LIST}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getCreateCohortGroupSession(params) {
    return api
      .POST(`${GET_CREATE_COHORT_GROUP_SESSION}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getDeleteCohortGroupSession(params) {
    return api
      .POST(`${GET_DELETE_COHORT_GROUP_SESSION}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getDetailsCohortGroupSession(params) {
    return api
      .POST(`${GET_DETAILS_COHORT_GROUP_SESSION}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getListCohortGroupSession(params) {
    return api
      .POST(`${GET_LIST_COHORT_GROUP_SESSION}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getListCohortGroupSessionCounters(params) {
    return api
      .POST(`${GET_LIST_COHORT_GROUP_SESSION_COUNTERS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getListCohortInvitation(params) {
    return api
      .POST(`${GET_LIST_COHORT_INVITATION}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  // 
  getListSessionMembers(params) {
    return api
      .POST(`${GET_LIST_SESSION_MEMBERS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  updateSessionStatus(params) {
    return api
      .POST(`${UPDATE_SESSION_STATUS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  giveCohortSessionFeedBack(params) {
    return api
      .POST(`${COHORT_SESSION_GIVE_FEEDBACK}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  viewCohortSessionFeedBack(params) {
    return api
      .POST(`${COHORT_SESSION_VIEW_FEEDBACK}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  giveCohortSessionNotesFeedBack(params) {
    return api
      .POST(`${COHORT_SESSION_NOTES_GIVE_FEEDBACK}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  viewCohortSessionNotesFeedBack(params) {
    return api
      .POST(`${COHORT_SESSION_NOTES_VIEW_FEEDBACK}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getCohortGroupSessionHours(params) {
    return api
      .POST(`${COHORT_GROUP_SESSION_HOURS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getCohortGroupSessionHoursFilter(params) {
    return api
      .POST(`${COHORT_GROUP_SESSION_HOURS_FILTER}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postCohortSpotlightAPI(params) {
    return api
      .POST(`${COHORT_PROGRAM_SPOTLIGHT_POST}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postCohortCommonAPI(params) {
    return api
      .POST(`${COHORT_COMMON_LIST_POST}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postCohortThreadAPI(params) {
    return api
      .POST(`${COHORTS_DISCUSSION_POST_API}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postCohortThreadListAPI(params) {
    return api
      .POST(`${COHORTS_DISCUSSION_LIST_API}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postCohortThreadCommentsListAPI(params) {
    return api
      .POST(`${COHORTS_DISCUSSION_COMMENT_LIST_API}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postCohortThreadCommentAPI(params) {
    return api
      .POST(`${COHORTS_DISCUSSION_POST_COMMENT_API}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postCohortLikeCommentAPI(params) {
    return api
      .POST(`${COHORTS_LIKE_POST_COMMENT_API}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postCohortLikeThreadAPI(params) {
    return api
      .POST(`${COHORTS_LIKE_POST_THREAD_API}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postCohortUnLikeCommentAPI(params) {
    return api
      .POST(`${COHORTS_UNLIKE_POST_COMMENT_API}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postCohortUnLikeThreadAPI(params) {
    return api
      .POST(`${COHORTS_UNLIKE_POST_THREAD_API}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postCohortThreadRemoveAPI(params) {
    return api
      .POST(`${COHORTS_THREAD_POST_REMOVE_API}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postCohortCommentRemoveAPI(params) {
    return api
      .POST(`${COHORTS_POST_COMMENT_REMOVE_API}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postCohortCommentReplyAPI(params) {
    return api
      .POST(`${COHORTS_POST_COMMENT_REPLY_API}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postCohortCommentReplyListAPI(params) {
    return api
      .POST(`${COHORTS_POST_COMMENT_REPLY_LIST_API}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postCohortDashboardActivityAPI(params) {
    return api
      .POST(`${COHORTS_DASHBOARD_ACTIVITY_API}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postCohortDashboardMentorCounterAPI(params) {
    return api
      .POST(`${COHORTS_DASHBOARD_MENTOR_API}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postCohortDashboardStartupCounterAPI(params) {
    return api
      .POST(`${COHORTS_DASHBOARD_STARTUP_API}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  // COHORT_SESSION_GIVE_FEEDBACK,
  // COHORT_SESSION_VIEW_FEEDBACK,
};